































import axios from "axios";
import moment from "moment";
import Excel from "@/models/Excel.ts";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { AgGridVue } from "ag-grid-vue";

@Component({
  components: { AgGridVue },
})
export default class TabularDatasetTable extends Vue {
  @Prop() private hack?: number;
  @Prop() private tabIndex?: number;
  @Prop() private factID?: number;

  private columnDefs = columnDefs;
  private gridOptions: any = {};

  private dataset = []; // contains the actual records

  created() {
    // this.load();
  }

  async load() {
    let response = await axios.post(
      "/psql/rpc/get_fact_tabular_datasets_records",
      { fact_id: this.factID }
    );
    this.dataset = response.data;
  }

  async save() {
    this.gridOptions.api.showLoadingOverlay();
    // update selection data
    this.gridOptions.api.forEachNode((node: any) => {
      node.data._in = node.selected;
    });

    const payload = {
      fact_id: this.factID,
      dataset: this.dataset
        .filter((row: any) => row._in)
        .map((row: any) => ({
          id: row.tabular_datasets_records_to_facts_id,
          tdr_id: row.id,
          f_id: this.factID,
        })),
    };

    try {
      let response = await axios.post(
        "/psql/rpc/save_tabular_datasets_records_to_facts",
        { api_data: payload }
      );
      const { _inserted, _deleted } = response.data;
      console.log(response);
      this.$Notice.success({
        title: "Saved successfully",
        desc: `${_inserted} added, ${_deleted} removed`,
      });
      await this.load();
    } catch (error) {
      console.error(error);
      this.$Notice.error({
        title: "Failed to associate records",
        desc: error.data,
      });
    }
    this.gridOptions.api.hideOverlay();
  }

  getRowStyle(params: any) {
    const row = params.data;
    if (!row._in) {
      return { backgroundColor: "#f6f6eb" };
    }
    return { backgroundColor: "#ffffff" };
  }

  // onSelectionChanged(event: any) {
  //   this.gridOptions.api.forEachNode((node: any) => {
  //     console.log(node.selected);
  //     node.data._in = node.selected;
  //   });
  //   // this.gridOptions.api.redrawRows();
  // }

  onGridReady(params: any) {
    // @ts-ignore
    this.gridOptions.api.closeToolPanel();
  }

  onRowDataChanged() {
    this.gridOptions.api.forEachNode((node: any) => {
      node.setSelected(node.data._in);
    });
    this.gridOptions.api.redrawRows();
  }

  hideEmptyColumns() {
    // @ts-ignore
    const api = this.gridOptions.columnApi;
    const columns = this.gridOptions.columnApi.getAllColumns();
    // hide others if empty
    for (let column of columns) {
      const field = column.colDef.field;
      api.setColumnVisible(
        field,
        this.dataset.reduce(
          (result: boolean, row: any) => result || !!row[field],
          false
        )
      );
    }
    // always hide these
    this.gridOptions.api.refreshHeader();
    this.gridOptions.api.sizeColumnsToFit();
  }

  // exportExcel exports the data grid into an excel with the dataset name as file name
  exportExcel() {
    const filename = `${this.factID}_records.xlsx`;
    const excelFile = new Excel();
    const headers = this.gridOptions.columnApi
      .getAllColumns()
      .filter((column: any) => !column.colDef.checkboxSelection)
      .map((column: any) => column.colDef.headerName);
    excelFile
      .addSheet(
        "Dataset",
        headers,
        headers,
        this.dataset.filter((row: any) => row._in)
      )
      .download(filename);
  }

  @Watch("hack")
  async onHackChanged(value: number) {
    if (value === this.tabIndex) {
      this.gridOptions.api.showLoadingOverlay();
      await this.load();
      this.gridOptions.api.hideOverlay();
      this.gridOptions.api.redrawRows();
    } else {
      this.dataset = [];
    }
  }
}

const columnDefs = [
  {
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    width: 80,
    resizable: false,
    filter: true,
  },
  {
    headerName: "tabular_dataset_name",
    field: "tabular_dataset_name",
    resizable: true,
    filter: true,
  },
  {
    headerName: "event_name",
    field: "event_name",
    resizable: true,
    filter: true,
  },
  {
    headerName: "start_date",
    field: "start_date",
    valueFormatter: (params: any) => {
      const { value } = params;
      if (value && value !== "") {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    resizable: true,
    filter: true,
  },
  {
    headerName: "end_date",
    field: "end_date",
    valueFormatter: (params: any) => {
      const { value } = params;
      if (value && value !== "") {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    resizable: true,
    filter: true,
  },
  {
    headerName: "org_name",
    field: "org_name",
    resizable: true,
    filter: true,
  },
  {
    headerName: "org_accuracy",
    field: "org_accuracy",
    resizable: true,
    filter: true,
  },
  {
    headerName: "org_lat",
    field: "org_lat",
    resizable: true,
    filter: true,
  },
  {
    headerName: "org_lon",
    field: "org_lon",
    resizable: true,
    filter: true,
  },
  { headerName: "dst_name", field: "dst_name", editable: true },
  {
    headerName: "dst_accuracy",
    field: "dst_accuracy",
    resizable: true,
    filter: true,
  },
  {
    headerName: "dst_lat",
    field: "dst_lat",
    resizable: true,
    filter: true,
  },
  {
    headerName: "dst_lon",
    field: "dst_lon",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_total",
    field: "stock_total",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_male",
    field: "stock_male",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_female",
    field: "stock_female",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_in_camp",
    field: "stock_in_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_outside_camp",
    field: "stock_outside_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_age_cat_01",
    field: "stock_age_cat_01",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_age_cat_02",
    field: "stock_age_cat_02",
    resizable: true,
    filter: true,
  },
  {
    headerName: "stock_age_cat_03",
    field: "stock_age_cat_03",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_total",
    field: "new_total",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_male",
    field: "new_male",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_female",
    field: "new_female",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_in_camp",
    field: "new_in_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_outside_camp",
    field: "new_outside_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_age_cat_01",
    field: "new_age_cat_01",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_age_cat_02",
    field: "new_age_cat_02",
    resizable: true,
    filter: true,
  },
  {
    headerName: "new_age_cat_03",
    field: "new_age_cat_03",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_total",
    field: "returns_total",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_male",
    field: "returns_male",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_female",
    field: "returns_female",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_in_camp",
    field: "returns_in_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_outside_camp",
    field: "returns_outside_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_age_cat_01",
    field: "returns_age_cat_01",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_age_cat_02",
    field: "returns_age_cat_02",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returns_age_cat_03",
    field: "returns_age_cat_03",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_total",
    field: "returnees_total",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_male",
    field: "returnees_male",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_female",
    field: "returnees_female",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_in_camp",
    field: "returnees_in_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_outside_camp",
    field: "returnees_outside_camp",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_age_cat_01",
    field: "returnees_age_cat_01",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_age_cat_02",
    field: "returnees_age_cat_02",
    resizable: true,
    filter: true,
  },
  {
    headerName: "returnees_age_cat_03",
    field: "returnees_age_cat_03",
    resizable: true,
    filter: true,
  },
  {
    headerName: "house_destroyed",
    field: "house_destroyed",
    resizable: true,
    filter: true,
  },
  {
    headerName: "house_damaged",
    field: "house_damaged",
    resizable: true,
    filter: true,
  },
  {
    headerName: "url",
    field: "url",
    resizable: true,
    filter: true,
  },
];
